// Modelo de vista PURO: contrato del backend -> estructura semanal unica (sin DOM, sin fetch, sin zona horaria implicita).
// Las fechas son cadenas ISO (YYYY-MM-DD) y se operan en UTC solo como calendario.

export const DAY_KEYS = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];

export const normalizeDia = (s) =>
  String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export const parseISO = (iso) => {
  const [y, m, d] = String(iso).split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};
export const toISO = (date) => date.toISOString().slice(0, 10);
export const addDays = (iso, n) => {
  const d = parseISO(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return toISO(d);
};
// Lunes (ISO) de la semana que contiene `iso`. Domingo pertenece a la semana que termina en el.
export const mondayOf = (iso) => addDays(iso, -((parseISO(iso).getUTCDay() + 6) % 7));
export const localTodayISO = (now = new Date()) => {
  const p = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
};

const isISO = (s) => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);

/** Valida la forma de la respuesta de horariosCozumel.php / horariosCalica.php. Lanza Error('invalid-payload'). */
export function parsePayload(payload) {
  if (!payload || typeof payload !== 'object' || !Array.isArray(payload.detail)) {
    throw new Error('invalid-payload');
  }
  const out = [];
  for (const it of payload.detail) {
    if (!it || typeof it.dia !== 'string' || typeof it.horario !== 'string' || !isISO(it.fecha_inicio) || !isISO(it.fecha_fin)) continue;
    out.push({
      dia: normalizeDia(it.dia),
      inicio: it.fecha_inicio,
      fin: it.fecha_fin,
      // El original hace horario.slice(0, -3) sobre "HH:MM:SS"
      hora: it.horario.length === 8 ? it.horario.slice(0, -3) : it.horario,
      mixed: Boolean(it.carga_negra), // semantica original: `if (item.carga_negra)`
    });
  }
  if (payload.detail.length > 0 && out.length === 0) throw new Error('invalid-payload');
  return out;
}

/** Horarios de un origen para una fecha ISO. Conserva el orden del backend y no deduplica (igual que el original). */
export function slotsFor(entries, iso) {
  const dia = DAY_KEYS[(parseISO(iso).getUTCDay() + 6) % 7];
  return entries.filter((e) => e.dia === dia && iso >= e.inicio && iso <= e.fin).map((e) => ({ time: e.hora, mixed: e.mixed, inicio: e.inicio, fin: e.fin }));
}

export const coverageEnd = (...lists) => lists.reduce((m, l) => l.reduce((mm, e) => (e.fin > mm ? e.fin : mm), m), '');

/**
 * Estructura semanal unica.
 * @returns {{weekStart,weekEnd,days:[{iso,index,dayKey,isToday,isSelected,date}],origins:[{id,slots:{[iso]:[{time,mixed}]}}],hasData,hasMixed,canPrev,canNext}}
 */
export function buildWeek({ weekStart, todayISO, selectedIndex, origins, currentWeekStart }) {
  const days = Array.from({ length: 7 }, (_, i) => {
    const iso = addDays(weekStart, i);
    return { iso, index: i, dayKey: DAY_KEYS[i], isToday: iso === todayISO, isSelected: i === selectedIndex };
  });
  const out = origins.map((o) => ({ id: o.id, slots: Object.fromEntries(days.map((d) => [d.iso, slotsFor(o.entries, d.iso)])) }));
  let hasData = false;
  let hasMixed = false;
  for (const o of out) {
    for (const d of days) {
      for (const s of o.slots[d.iso]) {
        hasData = true;
        hasMixed = hasMixed || s.mixed;
      }
    }
  }
  const end = coverageEnd(...origins.map((o) => o.entries));
  return {
    weekStart,
    weekEnd: addDays(weekStart, 6),
    days,
    origins: out,
    hasData,
    hasMixed,
    canPrev: weekStart > currentWeekStart,
    canNext: end !== '' && addDays(weekStart, 7) <= end,
  };
}
